import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import { getSinglePhyVeriMaster, savePhyVeriMaster } from '../../../services/asset.service';
import { getDepartmentList, getDivisionList } from '../../../services/user.service';
import FromFieldText from '../../../atoms/FromFieldText';
import FromFieldDate from '../../../atoms/FromFieldDate';
import * as CryptoJS from "crypto-js";
import Select from "react-select";
import './PhysicalVerification.css';

const TEXT_REGEX = /^[A-Za-z0-9-_/.@= ]+$/;

Date.prototype.dbFormatedDate = function () {
    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) { month = '0' + month; }
    if (day < 10) { day = '0' + day; }
    return year + '-' + month + '-' + day;
}

function getFormatedDate(dateString) {
    if (dateString !== null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) { month = '0' + month; }
        if (day < 10) { day = '0' + day; }
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

/* react-select custom styles — matches pv- design token */
const pvSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: '40px',
        border: state.isFocused ? '1.5px solid #0e8aca' : '1.5px solid #e2e6ef',
        borderRadius: '7px',
        background: state.isFocused ? '#fff' : '#f8f9fc',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(14,138,202,0.13)' : 'none',
        fontFamily: "'DM Sans', sans-serif",
        fontSize: '0.83rem',
        cursor: 'pointer',
        transition: 'all 0.22s ease',
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? '#0e8aca' : state.isFocused ? '#eef7fd' : '#fff',
        color: state.isSelected ? '#fff' : '#1e293b',
        fontSize: '0.83rem',
        cursor: 'pointer',
    }),
    placeholder: (base) => ({
        ...base,
        color: '#94a3b8',
        fontStyle: 'italic',
        fontSize: '0.83rem',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base) => ({ ...base, color: '#0e8aca' }),
    menu: (base) => ({
        ...base,
        borderRadius: '7px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
        border: '1px solid #e2e6ef',
        fontSize: '0.83rem',
        zIndex: 99,
    }),
};

const pvSelectStylesError = {
    ...pvSelectStyles,
    control: (base, state) => ({
        ...pvSelectStyles.control(base, state),
        border: '1.5px solid #fca5a5',
        background: '#fff8f8',
    }),
};

function PhysicalVerification() {
    const textRef = useRef();
    const errRef = useRef();

    const [pvtableno, setPvTableNo] = useState('');
    const [ErrPvTableNo, setErrPvTableNo] = useState('');
    const [companyId, setCompanyId] = useState(sessionStorage.getItem('LoggedInCompanyId'));
    const [divisions, setDivisions] = useState([]);
    const [division, setDivision] = useState('');
    const [ErrDivision, setErrDivision] = useState(false);
    const [startdate, setStartDate] = useState('');
    const [ErrStartDate, setErrStartDate] = useState('');
    const [enddate, setEndDate] = useState('');
    const [ErrEndDate, setErrEndDate] = useState('');
    const [extendedenddate, setExtendedEndDate] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [assetInfo, setAssetInfo] = useState({});
    const [selectedDivisionsOptions, setSelectedDivisionsOptions] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [selectedOwnershipOption, setSelectedOwnershipOption] = useState(null);
    const [ownershipId, setOwnershipId] = useState('');
    const [initialDivisionName, setInitialDivisionName] = useState('');
    const [initialDepartmentName, setInitialDepartmentName] = useState('');

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const masterid = query.get('mid');

    const isEditMode = masterid !== '' && masterid !== null;

    const resetAssetInfo = function () {
        setPvTableNo('');
        setDivision('');
        setStartDate('');
        setEndDate('');
        setSelectedDivisionsOptions(null);
        setSelectedOwnershipOption(null);
        setOwnershipId('');
    }

    // Fetch departments
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const EncryptData = CryptoJS.AES.encrypt(
                    JSON.stringify({ authToken: sessionStorage.getItem('LoggedInToken') }),
                    process.env.REACT_APP_ENCRYPT_SECRET_KEY
                ).toString();
                const oData = { token: EncryptData };
                const res = await getDepartmentList(oData);
                if (res?.data?.data?.length) {
                    setDepartments(res.data.data);
                } else {
                    setDepartments([]);
                }
            } catch (error) {
                setDepartments([]);
            }
        };
        fetchDepartments();
    }, []);

    // Fetch divisions
    useEffect(() => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData };
        getDivisionList(oData).then(res => {
            if (res?.data?.data?.length) { setDivisions(res.data.data); }
        });
    }, []);

    // Fetch master data when divisions and departments are ready
    useEffect(() => {
        if (masterid && divisions.length > 0 && departments.length > 0) {
            const decryptedBytes = CryptoJS.AES.decrypt(masterid.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            const decryptMasterId = decrypt_data.masterid;
            getPhyVerMasterId(decryptMasterId);
        } else if (!masterid) {
            resetAssetInfo();
        }
    }, [masterid, divisions, departments]);

    const optionListDivision = divisions && divisions.length > 0
        ? divisions.map((option) => ({ value: option.id, label: option.division_name }))
        : [{ value: "", label: "No Data" }];

    const optionListOwnership = departments && departments.length > 0
        ? departments.map((option) => ({ value: option.id, label: option.department_name }))
        : [{ value: 'no-data', label: 'No Data' }];

    function handleOwnership(data) {
        setSelectedOwnershipOption(data);
        setOwnershipId(data ? data.value : '');
    }

    function handleDivision(data) {
        setSelectedDivisionsOptions(data);
        setDivision(data ? data.value : '');
    }

    const getPhyVerMasterId = function (decryptMasterId) {
        resetAssetInfo();
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'master_id': decryptMasterId },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData1 = { 'token': EncryptData };

        getSinglePhyVeriMaster(oData1).then(function (res) {
            if (res?.data?.data) {
                var aInfo = res.data.data[0];
                setAssetInfo(aInfo);
                setPvTableNo(aInfo.phy_varify_table_name);
                setStartDate(new Date(aInfo.start_date));
                setEndDate(new Date(aInfo.end_date));
                setExtendedEndDate(new Date(aInfo.extended_end_date));
                setInitialDivisionName(aInfo.division_name);
                setInitialDepartmentName(aInfo.department_name);

                const selectedDiv = divisions.find(d => d.division_name === aInfo.division_name);
                if (selectedDiv) {
                    setDivision(selectedDiv.id);
                    setSelectedDivisionsOptions({ value: selectedDiv.id, label: selectedDiv.division_name });
                }
                const selectedDept = departments.find(d => d.department_name === aInfo.department_name);
                if (selectedDept) {
                    setOwnershipId(selectedDept.id);
                    setSelectedOwnershipOption({ value: selectedDept.id, label: selectedDept.department_name });
                }
            } else {
                setErrMsg('Details Not Found');
            }
        });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let valid_Name = true;

        if (!TEXT_REGEX.test(pvtableno)) {
            setErrPvTableNo('PV Table name is required');
            valid_Name = false;
        } else { setErrPvTableNo(''); }

        if (!division) {
            setErrDivision('Division name is required');
            valid_Name = false;
        } else { setErrDivision(''); }

        if (!startdate) {
            setErrStartDate('Start Date is required');
            valid_Name = false;
        } else { setErrStartDate(''); }

        if (!enddate) {
            setErrEndDate('End Date is required');
            valid_Name = false;
        } else { setErrEndDate(''); }

        if (valid_Name) { saveData(); }
    }

    const saveData = function () {
        try {
            var obj = {
                'company_id': sessionStorage.getItem('LoggedInCompanyId'),
                'phy_varify_table_name': pvtableno,
                'division': division,
                'department': ownershipId,
                'start_date': getFormatedDate(startdate),
                'end_date': getFormatedDate(enddate),
                'extended_end_date': getFormatedDate(extendedenddate),
                'created_by': sessionStorage.getItem('LoggedInUserId'),
            };

            if (masterid !== '' && masterid !== null) {
                const decryptedBytes = CryptoJS.AES.decrypt(masterid.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                obj.master_id = decrypt_data.masterid;
            }

            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData1 = { 'token': EncryptData };

            savePhyVeriMaster(oData1).then(function (res) {
                if ((typeof (res.data.errors) !== "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    setPvTableNo('');
                    setDivisions([]);
                    setStartDate('');
                    setEndDate('');
                    setExtendedEndDate('');
                    setSelectedDivisionsOptions(null);
                    setSelectedOwnershipOption(null);
                    setOwnershipId('');
                }
            });
        } catch (err) {
            setSuccess(false);
            setErrMsg(err.data?.message || 'Insert/Update Failed');
            if (!err?.data) { setErrMsg('No Server Response'); }
            else if (err.data?.status === 409) { setErrMsg('Username Taken'); }
        }
    }

    return (
        <div class="al-page" id="all-asset-list-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="pv-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-clipboard2-check-fill"/>
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">
                            {isEditMode ? 'Edit Physical Verification Table' : 'Create Physical Verification Table'}
                        </h5>
                        <p className="al-page-subtitle">
                            {isEditMode
                                ? 'Update the verification schedule and assignment details'
                                : 'Set up a new physical verification schedule for your assets'}
                        </p>
                    </div>
                </div>
                {isEditMode && (
                    <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: '6px',
                        padding: '4px 12px', borderRadius: '20px', fontSize: '0.74rem',
                        fontWeight: 700, background: '#fefce8', color: '#854d0e',
                        border: '1.5px solid #fde047'
                    }}>
                        <i className="bi bi-pencil-fill"/> Edit Mode
                    </span>
                )}
            </div>

            {/* ══ ALERTS ══ */}
            {success && (
                <div className="pv-alert pv-alert-success" id="pv-alert-success" role="alert">
                    <i className="bi bi-check-circle-fill"/>
                    <span>{success}</span>
                </div>
            )}
            {errMsg && (
                <div className="pv-alert pv-alert-danger" id="pv-alert-error" role="alert">
                    <i className="bi bi-exclamation-triangle-fill"/>
                    <span>{errMsg}</span>
                </div>
            )}

            <form onSubmit={handleSubmit} id="pv-form" noValidate>

                {/* ── Card 1: Table Identity ── */}
                <div className="pv-card" id="pv-identity-card">
                    <div className="pv-card-header">
                        <i className="bi bi-table"/>
                        <h6>Table Identity</h6>
                    </div>
                    <div className="pv-card-body">
                        <div className="pv-form-grid">

                            {/* Physical Table Name */}
                            <div className="pv-form-group" id="pv-tablename-group">
                                <label className="pv-label" htmlFor="pv-tablename">
                                    Physical Table Name <span className="pv-required">*</span>
                                </label>
                                <input
                                    id="pv-tablename"
                                    type="text"
                                    className={`pv-input ${ErrPvTableNo ? 'pv-error' : ''}`}
                                    value={pvtableno}
                                    onChange={(e) => setPvTableNo(e.target.value)}
                                    placeholder="e.g. PV-2025-Q1"
                                />
                                {ErrPvTableNo && (
                                    <span className="pv-field-error">
                                        <i className="bi bi-exclamation-circle"/> {ErrPvTableNo}
                                    </span>
                                )}
                            </div>

                            {/* Empty right column placeholder */}
                            <div/>

                        </div>
                    </div>
                </div>

                {/* ── Card 2: Assignment ── */}
                <div className="pv-card" id="pv-assignment-card" style={{ marginTop: '18px' }}>
                    <div className="pv-card-header">
                        <i className="bi bi-diagram-3-fill"/>
                        <h6>Assignment</h6>
                    </div>
                    <div className="pv-card-body">
                        <div className="pv-form-grid">

                            {/* Department */}
                            <div className="pv-form-group" id="pv-department-group">
                                <label className="pv-label" htmlFor="pv-department">
                                    <i className="bi bi-building" style={{ color: '#0e8aca', fontSize: '0.8rem' }}/>
                                    Department
                                </label>
                                <Select
                                    inputId="pv-department"
                                    options={optionListOwnership}
                                    placeholder="Select department..."
                                    value={selectedOwnershipOption}
                                    onChange={handleOwnership}
                                    styles={pvSelectStyles}
                                    classNamePrefix="react-select"
                                />
                            </div>

                            {/* Division */}
                            <div className="pv-form-group" id="pv-division-group">
                                <label className="pv-label" htmlFor="pv-division">
                                    <i className="bi bi-geo-alt-fill" style={{ color: '#0e8aca', fontSize: '0.8rem' }}/>
                                    Division <span className="pv-required">*</span>
                                </label>
                                <Select
                                    inputId="pv-division"
                                    options={optionListDivision}
                                    placeholder="Select division..."
                                    value={selectedDivisionsOptions}
                                    onChange={handleDivision}
                                    styles={ErrDivision ? pvSelectStylesError : pvSelectStyles}
                                    classNamePrefix="react-select"
                                />
                                {ErrDivision && (
                                    <span className="pv-field-error">
                                        <i className="bi bi-exclamation-circle"/> {ErrDivision}
                                    </span>
                                )}
                            </div>

                        </div>
                    </div>
                </div>

                {/* ── Card 3: Schedule Dates ── */}
                <div className="pv-card" id="pv-dates-card" style={{ marginTop: '18px' }}>
                    <div className="pv-card-header">
                        <i className="bi bi-calendar3-range"/>
                        <h6>Verification Schedule</h6>
                    </div>
                    <div className="pv-card-body">
                        <div className="pv-dates-grid" id="pv-dates-grid">

                            {/* Start Date */}
                            <div className="pv-form-group" id="pv-startdate-group">
                                <FromFieldDate
                                    label="Start Date"
                                    inputValue={startdate}
                                    setInputValue={setStartDate}
                                    setErrorMsg={ErrStartDate}
                                    star="*"
                                />
                            
                                <FromFieldDate
                                    label="End Date"
                                    inputValue={enddate}
                                    setInputValue={setEndDate}
                                    setErrorMsg={ErrEndDate}
                                    star="*"
                                />
                            
                                <FromFieldDate
                                    label="Extended End Date"
                                    inputValue={extendedenddate}
                                    setInputValue={setExtendedEndDate}
                                />
                                <span className="pv-field-error" style={{ color: '#94a3b8', fontWeight: 400 }}>
                                    <i className="bi bi-info-circle"/> Optional
                                </span>
                            </div>

                        </div>
                    </div>
                </div>

                {/* ══ ACTION BAR ══ */}
                <div className="pv-action-bar" id="pv-action-bar">
                    {isEditMode ? (
                        <>
                            <button type="submit" className="al-btn al-btn-primary" id="pv-btn-update">
                                <i className="bi bi-check-circle"/> Update
                            </button>
                            <a href="/physical-verfication-list" style={{ textDecoration: 'none' }}>
                                <button type="button" className="al-btn al-btn-outline" id="pv-btn-cancel">
                                    <i className="bi bi-x-circle"/> Cancel
                                </button>
                            </a>
                        </>
                    ) : (
                        <button type="submit" className="al-btn al-btn-primary" id="pv-btn-save">
                            <i className="bi bi-save"/> SAVE
                        </button>
                    )}
                </div>

            </form>
        </div>
    );
}

export default PhysicalVerification;